import React from "react";
import styled from "styled-components";

import { StyledInput } from "../../../Styled-Components/styles";

import { InputAdornment } from "@material-ui/core";

import EasyPaymentButtons from "./EasyPaymentButtons/EasyPaymentButtons";
import DisplayName from "./DisplayName";
import ImpactVisualisation from "./ImpactVisualisation";

const StyledDonationImpact = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-item: center;
  width: 60vw;
  margin: 2vh auto;
`;
const DonationImpact = (props) => {
  const isMobile = window.innerWidth <= 800;

  return (
    <div>
      <StyledDonationImpact>
        <h4>How much would you like to donate?</h4>
        <StyledInput
          startAdornment={<InputAdornment position="start">£</InputAdornment>}
          value={props.payment}
          type="number"
          inputProps={{ inputMode: "decimal" }}
          onChange={(event) => props.setPayment(event.target.value)}
        />
        <EasyPaymentButtons
          payment={props.payment}
          setPayment={props.setPayment}
        />
      </StyledDonationImpact>
      <div
        style={{
          display: props.payment >= 5 ? "block" : "none",
          width: "100%",
        }}
      >
        <ImpactVisualisation payment={props.payment} />
        {/* <DisplayName
          payment={props.payment}
          mapDetails={props.mapDetails}
          setMapDetails={props.setMapDetails}
        /> */}
      </div>
    </div>
  );
};

export default DonationImpact;
